import { connect } from 'unistore/preact';
import { CACHE } from '../utils/constants';
import { getKey } from '../utils/common';

const convertJsonToCss = (styleObject = {}, containerClass) => {
  return Object.keys(styleObject).reduce((style, selector) => {
    const selectorValue = styleObject[selector];
    const selectorProperties = Object.keys(selectorValue);

    const selectorCss = selectorProperties.reduce((selectorCssValue, property) => {
      const value = selectorValue[property];

      if (value) {
        selectorCssValue += `${property}: ${value};\n`;
      }

      return selectorCssValue;
    }, '');

    if (selectorCss.length) {
      style += '\n';

      const prefixedSelector = selector
        .split(',')
        .map(currentSelector =>
          currentSelector.indexOf(containerClass) === -1
            ? currentSelector.replace('#paytm-app', `#paytm-app.${containerClass}`)
            : currentSelector
        )
        .join(',');

      style += `${prefixedSelector}{\n${selectorCss}\n}\n`;
    }
    return style;
  }, '');
};

const StyleComponent = ({ AppStyle, containerClass, cache }) => {
  const mConfig = cache.getData(CACHE.MERCHANT_CONFIG);
  const isGradientEffectEnable = getKey(mConfig, 'isGradientEffectEnable', false);
  const gradient = AppStyle.gradient;
  let headerBg;
  let buttonBg;
  if (
    isGradientEffectEnable &&
    gradient &&
    gradient.headerGradientsColors &&
    gradient.headerGradientsColors.length
  ) {
    headerBg = `linear-gradient(to bottom, ${gradient.headerGradientsColors[0]}, ${
      gradient.headerGradientsColors[1]
    })`;
  } else {
    headerBg = AppStyle.headerBackgroundColor;
  }
  if (
    isGradientEffectEnable &&
    gradient &&
    gradient.buttonGradientsColors &&
    gradient.buttonGradientsColors.length
  ) {
    buttonBg = `linear-gradient(to top, ${gradient.buttonGradientsColors[0]}, ${
      gradient.buttonGradientsColors[1]
    })`;
  } else {
    buttonBg = AppStyle.themeBackgroundColor;
  }
  const styleObject = {
    '#paytm-app': {
      color: AppStyle.bodyColor
    },
    '#paytm-app .ptm-border-color,#paytm-app .ptm-tool-tip,#paytm-app .ptm-triangle': {
      'border-color': AppStyle.borderColor
    },
    '#paytm-app .ptm-small-txt,#paytm-app .ptm-body-color,#paytm-app .ptm-input-common,#paytm-app .ptm-select-txt,#paytm-app .ptm-card-input,#paytm-app .ptm-upi-input,#paytm-app .ptm-container .ptm-paymode-name,#paytm-app .ptm-input-common::placeholder,#paytm-app .ptm-upi-input::placeholder,#paytm-app .ptm-container, #paytm-app .ptm-paymode-name': {
      color: AppStyle.bodyColor
    },
    '#paytm-app .ptm-input-common,#paytm-app .ptm-pnr-input,#paytm-app .ptm-global-border,#paytm-app span.ptm-global-border,#paytm-app .ptm-card-input,#paytm-app .ptm-upi-input,#paytm-app .ptm-emi-main .ptm-pay-method .ptm-pay-method,#paytm-app .ptm-select-bank:after,#paytm-app .cnvc-before-icon,#paytm-app .ptm-qr-zoom-wrap,#paytm-app .cnvc-before-icon:before,#paytm-app .ptm-change-plan': {
      'border-color': AppStyle.borderColor
    },
    '#paytm-app,#paytm-app .ptm-body-bg': {
      'background-color': AppStyle.bodyBackgroundColor
    },
    '#paytm-app .ptm-checkmark': {
      'background-color': 'transparent'
    },
    '#paytm-app ptm-lightblue-bg': {
      'background-color': AppStyle.headerColor
    },
    '#paytm-app .ptm-header-bg': {
      background: headerBg
    },
    ' #paytm-app .ptm-footer,#paytm-app .ptm-closeIcon': {
      background: AppStyle.headerBackgroundColor
    },
    '#paytm-app .ptm-pay-method::after,#paytm-app .nb-border:after,#paytm-app .ptm-global-bottom-border': {
      background: AppStyle.borderColor
    },
    '#paytm-app .ptm-header-color,#paytm-app .ptm-footer .ptm-text-blue,#paytm-app .ptm-logo-name': {
      color: AppStyle.headerColor
    },
    '#ptm-checkout-header .ptm-select-txt': {
      color: '#1d252d'
    },
    '#paytm-app .cnvc-before-icon:before,#paytm-app .ptm-tool-tip::after': {
      background: AppStyle.bodyBackgroundColor
    },
    '#paytm-app .ptm-header-color .ptm-arrow-down': {
      'border-color': AppStyle.headerColor
    },
    '#paytm-app .ptm-amount-color, #paytm-app .ptm-c-p label, #paytm-app .ptm-c-p span': {
      color: AppStyle.headerColor
    },
    '#paytm-app .arrow-color': {
      'border-color': AppStyle.headerColor
    },

    '#paytm-app .ptm-cross:before,#paytm-app .ptm-cross:after,#paytm-app .ptm-close-wrap .ptm-cross:before,#paytm-app .ptm-close-wrap .ptm-cross:after': {
      background: AppStyle.headerColor
    },
    '#paytm-app .ptm-cross.ptm-black:before,#paytm-app .ptm-cross.ptm-black:after': {
      background: '#000000'
    },
    '#paytm-app .ptm-custom-btn': {
      background: buttonBg,
      color: AppStyle.themeColor
    },
    '#paytm-app button, #paytm-app .ptm-scale-qr-type': {
      background: AppStyle.themeBackgroundColor,
      color: AppStyle.themeColor
    },
    '#paytm-app .ptm-nb-cancel-btn': {
      background: 'transparent',
      color: AppStyle.themeBackgroundColor
    },
    '#paytm-app span.ptm-btn-active,#paytm-app .ptm-close-wrap': {
      background: AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-checkmark,#paytm-app .check,#paytm-app .ptm-check,#paytm-app .ptm-container:hover input ~ .ptm-check': {
      'border-color': AppStyle.bodyColor
    },
    '#paytm-app .ptm-lbl input:checked ~ .ptm-checkmark': {
      'border-color': AppStyle.themeBackgroundColor,
      background: 'transparent'
    },
    '#paytm-app .ptm-lbl .ptm-checkmark:after': {
      background: AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-small-txt-link': {
      color: AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-activeBank': {
      'border-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-tick': {
      background: AppStyle.themeBackgroundColor,
      'border-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-sign1,#paytm-app .ptm-sign2': {
      color: AppStyle.themeColor
    },
    '#paytm-app .ptm-primary, #paytm-app a.ptm-primary': {
      color: AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-input-common:focus': {
      'border-color': AppStyle.themeBackgroundColor,
      'caret-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-container input:checked ~ .ptm-check': {
      'background-color': AppStyle.themeBackgroundColor,
      'border-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-container .check:after': {
      'border-color': AppStyle.themeColor
    },
    '#paytm-app .ptm-card-input:focus,#paytm-app .ptm-upi-input:focus, #paytm-app .ptm-pnr-input': {
      'border-color': AppStyle.themeBackgroundColor,
      'caret-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-lbl:hover input ~ .ptm-checkmark': {
      background: 'transparent'
    },
    '#paytm-app .border-button': {
      'border-color': AppStyle.themeBackgroundColor
    },
    '#paytm-app .ptm-txtcolor': {
      color: AppStyle.bodyColor
    },
    '#paytm-app .ptm-msg-red': {
      color: AppStyle.errorColor || '#ff585d' // adding default error color in case merchant doesnt pass the error color was being overwritten by body color
    },
    '#paytm-app .ptm-msg-info': {
      color: AppStyle.infoColor,
      background: AppStyle.infoBackgroundColor
    },
    '#paytm-app .successColor': {
      color: AppStyle.successColor
    },
    '#paytm-app .ptm-green-bh': {
      background: AppStyle.successColor
    },
    '#paytm-app .ptm-note-listing>li:before': {
      background: AppStyle.bodyColor
    },
    '#paytm-app .ptm-user-bg': {
      background: AppStyle.headerBackgroundColor,
      'border-color': AppStyle.headerColor
    },
    '#paytm-app .ptm-user-bg svg path': {
      fill: AppStyle.headerColor
    },
    '#paytm-app .ptm-header': {
      'box-shadow': '0 0 8px 0 rgba(0,0,0,.22)'
    },
    '#paytm-app .ptm-header_fix .ptm-amount span': {
      color: '#182233'
    },
    '#paytm-app .ptm-header_fix .ptm-amount div': {
      color: '#182233'
    },
    // css added in discussion with aditya related to opacity and color of button in disabled state
    '#paytm-app .ptm-disabled-btn': {
      background: '#4d4d4d',
      opacity: 0.2,
      'pointer-events': 'none'
    }
  };
  const css = convertJsonToCss(styleObject, containerClass);
  return <style>{css}</style>;
};

export default connect('AppStyle, cache')(StyleComponent);



// WEBPACK FOOTER //
// ./components/StyleComponent.js